import AddVehicle from "@app.automotus.io/components/scenes/SignUp/AddVehicle";
export { AddVehicle as Vehicle } from "@app.automotus.io/components/scenes/SignUp/AddVehicle";
export default AddVehicle;
